// https://boost.allnetru.dev/api/documentation/partner#/
import { createApi } from '@reduxjs/toolkit/query/react';
import { GetPartnerCredentialsResponse } from 'lib.store/src/type-partner/credentials/models';
import { baseQueryWithReauth } from '../../main/baseQueryWithReauth';

const partnerCredentials = `partner_credentials`;

export const adPartnerCredentials = createApi({
  reducerPath: partnerCredentials,
  baseQuery: baseQueryWithReauth,
  tagTypes: [partnerCredentials],
  endpoints: (build) => ({
    getCredentialsChannels: build.query<GetPartnerCredentialsResponse, void>({
      query: () => {
        return {
          url: '/credentials/channels',
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
        };
      },
      providesTags: [partnerCredentials],
    }),
  }),
});

export const { useGetCredentialsChannelsQuery } = adPartnerCredentials;
